// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAEFvMSYpktcDDlWZiD-6fYrLMu7XKVTtM",
  authDomain: "number-time.firebaseapp.com",
  projectId: "number-time",
  storageBucket: "number-time.appspot.com",
  messagingSenderId: "1032818730799",
  appId: "1:1032818730799:web:33eb9fd248ac22b30423da",
  measurementId: "G-KPT8WK9HPZ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);